import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TuiInputModule } from "@taiga-ui/kit";
import { KwikUIInputOtpMultipleComponent } from "./input-otp-multiple.component";
import { KeysPipe } from "./input-otp-multiple.pipe";

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TuiInputModule],
  declarations: [KwikUIInputOtpMultipleComponent, KeysPipe],
  exports: [KwikUIInputOtpMultipleComponent],
  providers: [KeysPipe]
})
export class KwikUIInputOtpMultipleModule {}
